import { render, staticRenderFns } from "./shopsStatusInput.vue?vue&type=template&id=376fba42&scoped=true&"
import script from "./shopsStatusInput.vue?vue&type=script&lang=js&"
export * from "./shopsStatusInput.vue?vue&type=script&lang=js&"
import style0 from "./shopsStatusInput.vue?vue&type=style&index=0&id=376fba42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fba42",
  null
  
)

export default component.exports